import Vue from 'vue'
import Vuetify from 'vuetify/lib'
import '@fortawesome/fontawesome-free/css/all.css'

import ArrowRight from '../components/_shared/svg/ArrowRight'
import ArrowLeft from '../components/_shared/svg/ArrowLeft'
import CarouselDelimiter from '../components/_shared/svg/CarouselDelimiter'
import ArrowLink from '../components/_shared/svg/LinkArrow'
import FooterArrow from '../components/_shared/svg/FooterArrow'
import Chat from '../components/_shared/svg/Chat'

Vue.use(Vuetify)

const theme = {
  'app-colors-background': '#3A3A3A',
  'app-light-grey': '#EFF0F3'
}

export default new Vuetify({
  icons: {
    values: {
      arrowRight: {
        component: ArrowRight
      },
      arrowLeft: {
        component: ArrowLeft
      },
      delimiter: {
        component: CarouselDelimiter
      },
      linkArrow: {
        component: ArrowLink
      },
      footerArrow: {
        component: FooterArrow
      },
      chat: {
        component: Chat
      }
    }
  },
  theme: {
    options: {
      customProperties: true
    },
    themes: {
      light: theme
    }
  },
  breakpoint: {
    mobileBreakpoint: 'xs'
  }
})
